import { render } from "./ArtistsList.vue?vue&type=template&id=0389d14f&scoped=true"
import script from "./ArtistsList.vue?vue&type=script&lang=js"
export * from "./ArtistsList.vue?vue&type=script&lang=js"

import "./ArtistsList.vue?vue&type=style&index=0&id=0389d14f&scoped=true&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0389d14f"]])

export default __exports__